module.exports = __webpack_public_path__ + "static/media/butterfly.c928f075.mp3";